import React, { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { rateSellerOrder } from '../api';
import { customerOrdersKey } from '../hooks/useCustomerOrders';

export default function SellerRatingForm({ slice }) {
  const [score, setScore] = useState(slice.sellerRating);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const queryClient = useQueryClient();

  const rate = async value => {
    if (busy || value === score) return;
    setBusy(true);
    setError('');
    try {
      const { data } = await rateSellerOrder(slice.id, value);
      setScore(data.score);
      queryClient.invalidateQueries({ queryKey: ['seller-shop', Number(slice.sellerId)] });
      queryClient.invalidateQueries({ queryKey: customerOrdersKey });
    } catch (e) { setError(e.response?.data?.error || 'Не удалось сохранить оценку. Попробуйте снова.'); }
    finally { setBusy(false); }
  };

  return <div className="seller-rating-form">
    <span>{score ? `Ваша оценка ${score} из 5` : 'Оцените продавца'}</span>
    <div className="seller-rating-stars" role="group" aria-label={`Оценка продавца ${slice.sellerName || ''}`}>
      {[1, 2, 3, 4, 5].map(value => <button key={value} className={value <= score ? 'is-rated' : ''} type="button" disabled={busy} aria-label={`Оценка ${value} из 5`} aria-pressed={value === score} onClick={() => rate(value)}>★</button>)}
    </div>
    {error && <p role="alert">{error}</p>}
  </div>;
}
